<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Saldo</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">SaldoInicial</th>
          <th scope="col">TotalDebito</th>
          <th scope="col">TotalCredito</th>
          <th scope="col">SaldoFinal</th>
          <th scope="col">CodigoCuenta</th>
          <th scope="col">NombreCuenta</th>
          <th scope="col">EstadoCuenta</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="saldo in datosPaginados" :key="saldo.idSaldo">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(saldo.idSaldo)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(saldo.idSaldo)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(saldo.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(saldo.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{saldo.saldoInicial}}</td>
          <td>{{saldo.totalDebito}}</td>
          <td>{{saldo.totalCredito}}</td>
          <td>{{saldo.saldoFinal}}</td>
          <td>{{saldo.codigoCuenta}}</td>
          <td>{{saldo.nombreCuenta}}</td>
          <td>{{saldo.estadoCuenta}}</td>
          <td>{{saldo.usuarioNombre}}</td>
          <td>{{saldo.empresaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteSaldo(saldo.idSaldo)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idSaldo" class="form-label">IdSaldo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSaldo" name="idSaldo" v-model="datoSaldo.idSaldo" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Cuenta -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idCuenta" class="form-label"> Cuenta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCuenta" name="idCuenta" v-model="datoSaldo.idCuenta">
                      <option v-for="cuenta in cuentas" :value="cuenta.idCuenta" :key="cuenta.idCuenta">
                        {{ cuenta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Cuenta -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoSaldo.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoSaldo.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoSaldo.fechaHasta" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="saldoInicial" class="form-label">SaldoInicial</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="saldoInicial" name="saldoInicial" v-model="datoSaldo.saldoInicial" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="totalDebito" class="form-label">TotalDebito</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="totalDebito" name="totalDebito" v-model="datoSaldo.totalDebito" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="totalCredito" class="form-label">TotalCredito</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="totalCredito" name="totalCredito" v-model="datoSaldo.totalCredito" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="saldoFinal" class="form-label">SaldoFinal</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="saldoFinal" name="saldoFinal" v-model="datoSaldo.saldoFinal" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarSaldo" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSaldo" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      saldos : [],
      datoSaldo : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      cuentas: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchCuentas()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.saldos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwsaldos/nombre/'+this.nombreBusqueda).then(response=>{
          this.saldos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.saldos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwsaldos').then(response=>{
      this.saldos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.saldos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idCuenta'
        ,'idUsuario'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'saldoInicial'
        ,'totalDebito'
        ,'totalCredito'
        ,'saldoFinal'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idCuenta'
        ,'idUsuario'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'saldoInicial'
        ,'totalDebito'
        ,'totalCredito'
        ,'saldoFinal'
      ];
      return validarForm(this.datoSaldo, requiredFields, requiredFieldsText);
    },
    async guardarSaldo(){
      if(this.validarForm() === 1){
        try {
          this.datoSaldo.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          this.datoSaldo.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/saldos', this.datoSaldo)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Saldo creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSaldo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/saldos', this.datoSaldo)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Saldo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoSaldo={}
      this.titulo   = 'Crear Saldo'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idSaldo){
      this.modalWindow = true
      if(idSaldo != null){    
           api.get('/vwsaldos/'+idSaldo).then(resp=>{
          this.datoSaldo = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Saldo'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idSaldo){
      if(idSaldo != null){
        this.$router.push('/saldomd/'+idSaldo)
      }
    },
    async deleteSaldo (idSaldo) {
      try{
        await api.delete('/saldos/'+idSaldo)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchCuentas() {
      fetch('http://localhost:8080/api/v1/cuentas')
        .then(response => response.json())
        .then(data => {
          this.cuentas = data;
        })
        .catch(error => {
          console.error('Error fetching cuentas:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
